import { useWidget } from '@telescope/cassini-hooks';
import { Container, Heading } from '@telescope/cassini-ui';
import { Text } from 'components';
import { Winner } from 'generated-types/widget';

export const BracketViewHeader = () => {
  const {
    data: { content, styles },
  } = useWidget<Winner>({ select: (data) => data.snapshot.snapshot_views.winnerPage });

  return (
    <Container
      className="BracketViewHeader__root"
      centerContent
      mb={{ base: 6, lg: 0 }}
      py={8}
      {...styles?.bracketSectionHeaderRoot}>
      <Heading
        className="BracketViewHeader__headline"
        as="h1"
        size="lg"
        variant="emphasized"
        {...styles?.bracketSectionHeaderHeadline}>
        {content.bracketHeadline}
      </Heading>
      <Text
        className="BracketViewHeader__description"
        allowMarkdown
        mb={3}
        {...styles?.bracketSectionHeaderDescription}>
        {content.bracketDescription}
      </Text>
    </Container>
  );
};
